<template>
	<div>
        <div class="img-foverlay img-color-overlay">
            <div class="container">
              <div class="row section-separator xs-column-reverse vertical-middle-content home-padding">
                <div class="col-sm-6">
                  <div class="mh-header-info">
                    <div class="mh-promo wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.1s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.1s; animation-name: fadeInUp;">
                      <span>{{ $t('home.hello') }}</span>
                    </div>
                    <h2 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>{{ $t('home.liuxin') }}</span>
                        <span class="fs-16">（Louis Liu）</span>
                    </h2>
                    <h4 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.3s; animation-name: fadeInUp;">
                        {{ $t('home.fullStackDeveloper') }}
                    </h4>
                    <h5 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: fadeInUp;">
                      Java, Next.js, Vue.js, Web3
                    </h5>
                    <ul class="pl-0">
                      <li class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: fadeInUp;">
                        <i class="fa fa-envelope"></i><a href="mailto:louis.liu.oneself@hotmail.com">louis.liu.oneself@hotmail.com</a>
                      </li>
                      <!-- <li class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.5s; animation-name: fadeInUp;">
                        <i class="fa fa-phone"></i><a href="callto:+86 159 3597 5736">+86 159 3597 5736</a>
                      </li> -->
                      <li class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.6s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.6s; animation-name: fadeInUp;">
                        <i class="fa fa-map-marker"></i>
                        <a href="https://www.amap.com/ssr/search?query_type=TQUERY&query=%E5%8E%86%E4%B8%8B%E5%8C%BA&city=370100&geoobj=117.00%7C36.59%7C117.32%7C36.74&zoom=12.14&isCity=true" target="_blank">
                            <address class="font-family">
                                <a>{{ $t('home.address') }}</a>
                            </address>
                        </a>
                      </li>
                    </ul>
                    <!-- 二维码 -->
                    <ul class="pl-0 social-icon wow fadeInUp text-center" data-wow-duration="0.8s" data-wow-delay="0.7s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.7s; animation-name: fadeInUp;">
                        <li>
                            <img src="/static/images/profile/wechat-offiaccount.jpg" class="wechat" /><br/>
                            <span class="wechat-text font-family">@一个正经的程序员</span><br/>
                            <span class="wechat-text font-family">{{ $t('home.scanToFollow') }}</span>
                        </li>
                        <li class="ml-5">
                            <img src="/static/images/profile/wechat-simple.png" class="wechat" /><br/>
                            <span class="wechat-text font-family">@散淡样子</span><br/>
                            <span class="wechat-text font-family">{{ $t('home.scanIt') }}</span>
                        </li>
                    </ul>
                    <br/>
                    <!-- 社交账号 -->
                    <div class="pl-0 social-icon social-account wow fadeInUp font-family" data-wow-duration="0.8s" data-wow-delay="0.8s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.7s; animation-name: fadeInUp;">
                        <h4>{{ $t('home.socialAccount') }}</h4>
                    </div>
                    <br/>
                    <div class="pl-0 ml-n4 social-icon wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.9s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.7s; animation-name: fadeInUp;">
                        <li><a target="_blank" href="/static/images/profile/wechat.png"><v-icon>fa-brands fa-weixin</v-icon></a></li>
                        <li><a target="_blank" href="/static/images/profile/qq.png"><v-icon>fa-brands fa-qq</v-icon></a></li>
                        <li><a target="_blank" href="https://join.skype.com/invite/UXz3DrrMVzjh"><v-icon>fa-brands fa-skype</v-icon></a></li>
                        <li><a target="_blank" href="https://www.linkedin.com/in/louisliuoneself"><v-icon>fa-brands fa-linkedin</v-icon></a></li>
                    </div><br/>
                    <div class="pl-0 ml-n4 social-icon wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="1.0s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.7s; animation-name: fadeInUp;">
                        <li><a target="_blank" href="https://github.com/LouisLiu00"><v-icon>fa-brands fa-github</v-icon></a></li>
                        <li><a target="_blank" href="https://twitter.com/LouisLiuOneself"><v-icon>fa-brands fa-twitter</v-icon></a></li>
                        <li><a target="_blank" href="https://www.facebook.com/LouisLiuOneself"><v-icon>fa-brands fa-facebook</v-icon></a></li>
                        <li><a target="_blank" href="https://t.me/Louis_Liu"><v-icon>fa-brands fa-telegram</v-icon></a></li>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="hero-img wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.6s" style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.6s; animation-name: fadeInUp;">
                    <div class="img-border">
                      <img src="/static/images/profile/LiuXin-AI-Square.PNG" alt="" class="img-fluid">
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>
.wechat{
    width: 120px;
    height: 120px;
}
.wechat-text{
    font-size: 12px;
}
.social-account{
    padding-top: 30px;
    margin-bottom: -20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue